var map = {
	"./banners/coober-pedy.jpg": 9466,
	"./boat-stock.png": 1564,
	"./casestudies.jpg": 3300,
	"./checkbox-tick.svg": 3763,
	"./computers.png": 3421,
	"./connect-bg.png": 4721,
	"./connect-plus-background.jpeg": 7336,
	"./connectplus.jpg": 2377,
	"./default.png": 248,
	"./dti-share.jpg": 5944,
	"./export-adviser.jpg": 260,
	"./export-fundamentals-program.jpeg": 7308,
	"./file-type-icons/doc.svg": 7641,
	"./file-type-icons/file.svg": 3115,
	"./file-type-icons/pdf.svg": 5989,
	"./file-type-icons/ppt.svg": 3939,
	"./file-type-icons/zip.svg": 466,
	"./global-office.jpg": 2821,
	"./home-carousel/adelaide-oval.jpg": 2894,
	"./home-carousel/sahmri.jpg": 522,
	"./home-carousel/wind-energy.jpg": 8085,
	"./home/how-we-work-with-you-banner.jpg": 5554,
	"./home/investors-banner.jpg": 7149,
	"./home/trade-and-exporters-banner.jpg": 9505,
	"./international-market-adviser.jpg": 8791,
	"./invest.png": 1496,
	"./invest/business-banner.jpg": 9564,
	"./invest/business.jpg": 4555,
	"./invest/invest-banner.jpg": 5307,
	"./invest/vines.jpg": 3646,
	"./investment-tool.png": 7721,
	"./logo-sagov-carousel.png": 2878,
	"./logo-sagov-footer.png": 6721,
	"./logo-sagov-invest-footer.png": 7107,
	"./logo-sagov-invest-vertical.png": 6452,
	"./logo-sagov-vertical.png": 2854,
	"./logo.png": 4010,
	"./logos/sa-gov.png": 9735,
	"./person-fallback.png": 2421,
	"./region.jpg": 2203,
	"./roos.png": 968,
	"./sa-map-bg.png": 6508,
	"./sector-fallback.jpg": 9682,
	"./sector.jpg": 2081,
	"./select-arrow.svg": 5692,
	"./training-opportunity.jpg": 4381
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6190;